import { createStyles, makeStyles } from '@material-ui/core'

export const useClassAssignmentsStyles = makeStyles(() =>
	createStyles({
		divider: { margin: '40px 0 0 0' }
	})
)

export default useClassAssignmentsStyles
